import script from "./TabelaLicencas.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabelaLicencas.vue?vue&type=script&lang=ts&setup=true"

import "./TabelaLicencas.vue?vue&type=style&index=0&id=5d519018&lang=css"

const __exports__ = script;

export default __exports__